import React, { memo, useEffect, useState } from "react";
import ListboxEmploye from "@components/tailwindComponents/ListboxEmploye";
import { getInitPeriodFilterMonthe } from "@helpers/_functions";
import { useSelector } from "react-redux";
import { ListboxSimple } from "@components/tailwindComponents";
import DateRangePickerDropdown from "@components/dateRange/DropdownDateRange";
import Button from "@components/tailwindComponents/Button";
import { useReduxSelector } from "@hooks/useReduxSelector";
import moment from "moment-timezone";

function DisciplinaryFilter({ setDataFilter, t }) {
    const [period, setPeriod] = useState(getInitPeriodFilterMonthe());
    const [employeeSelected, setEmploye] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedGradation, setSelectedGradation] = useState([]);
    const [dateChanged, setDateChanged] = useState(false);
    const disciplinaryCategoryList = useReduxSelector(({ disciplinary }) => disciplinary.disciplinaryCategory.list);
    const disciplinaryGradationList = useReduxSelector(({ disciplinary }) => disciplinary.disciplinaryGradation.list);
    const employers = useSelector((state) => state.commonData.employers);

    // Use Effect
    useEffect(() => {
        if (!dateChanged) {
            setDateChanged(true);
        }
    }, [period]);
    // End Use Effect

    const handleChangePeriod = (date) => {
        setPeriod(date?.[0]);
    };

    const resetDateFilter = () => {
        setPeriod({
            startDate: null,
            endDate: null
        });
    };

     useEffect(() => {
        if (
          !selectedGradation.length &&
          !selectedCategory.length &&
          !employeeSelected.length &&
          !period.startDate &&
          !period.endDate
        ) {
          setDataFilter({
            period: {
              startDate: moment("2000-01-01").toDate(),
              endDate: moment("2100-12-31").toDate(),
            },
            employees: [],
            category: [],
            gradation : []
          }, false);
        }
      }, [
        selectedCategory,
        selectedGradation,
        employeeSelected,
        period
      ]);

    const onApplyFilter = async () => {
        let nPeriod = period;
        if (!nPeriod?.startDate || !nPeriod?.endDate) {
          nPeriod = getInitPeriodFilterMonthe();
          setPeriod(nPeriod);
        }
        const data = {
          period: nPeriod,
          employees: employeeSelected,
          category: selectedCategory,
          gradation: selectedGradation
        };
        await setDataFilter(data, dateChanged);
        setDateChanged(false);
      };
  
    return (
        <div className="arh-w-full arh-rounded arh-bg-greyColor arh-p-4">
            <div className="arh-grid arh-grid-cols-5 arh-gap-5">
                <ListboxEmploye
                    placeholder={t("Employé")}
                    name="employe"
                    optionList={employers || []}
                    selectedValue={employeeSelected}
                    setSelectedValue={setEmploye}
                    multiple
                    showReset={Boolean(employeeSelected?.length)}
                    customClass="arh-ml-[0.925rem]"
                />

                <div className="datepicker_modals_parcours">
                    <div className="dateRange_green DateRangePicker_customisation DateRangePicker_customisation--green arh-relative">
                        <DateRangePickerDropdown
                            key="date_range_periode"
                            classParent="arhDatePicker"
                            idInput="daterange"
                            className="input_simple"
                            dateSelected={period}
                            textInput={t("Date/Période")}
                            SaveCloseRange={handleChangePeriod}
                            showResetFilter={
                            period.startDate && period.endDate ? true : false
                            }
                            onResetFilter={resetDateFilter}
                            classSwitch="c-switch-pill-checked--green--color--to--left"
                            classBackground="green"
                        />
                    </div>
                </div>
                <ListboxSimple
                    placeholder={t("Catégorie")}
                    name="category"
                    optionList={disciplinaryCategoryList || []}
                    selectedValue={selectedCategory}
                    setSelectedValue={setSelectedCategory}
                    showReset={Boolean(selectedCategory?.length)}
                    multiple={true}
                    withTooltip
                />

                <ListboxSimple
                    placeholder={t("Gradation")}
                    name="gradation"
                    optionList={disciplinaryGradationList || []}
                    selectedValue={selectedGradation}
                    setSelectedValue={setSelectedGradation}
                    showReset={Boolean(selectedGradation?.length)}
                    multiple={true}
                    withTooltip
                />
                <Button onClick={onApplyFilter} >
                    {t("Appliquer")}
                </Button>
            </div>
        </div>
    );
}

export default memo(DisciplinaryFilter);